import Footer from "./footer";
import Wallet_modal from "./modal/wallet_modal";
import TransferToExchangeModal from "./modal/transferToExchangeModal";
import MintModal from "./modal/mintModal";
import BurnModal from "./modal/burnModal";
import ProjectSettingsModal from "./modal/projectSettingsModal";
import { Hero } from "./component";
import React from "react";
import HeaderAuthenticated from "./header/HeaderAuthenticated";
import {useAuth} from "react-oidc-context";
import BuyModal from "./modal/buyModal";

export default function Layout({ children }) {
    const auth = useAuth();

  return (
    <>
      {auth.isAuthenticated && <HeaderAuthenticated />}
      <Wallet_modal />
      <TransferToExchangeModal />
      <MintModal />
      <BurnModal />
      <BuyModal />
      <ProjectSettingsModal />
      {auth.isAuthenticated && <main>{children}</main>}
      {!auth.isAuthenticated && <Hero />}
      <Footer />
    </>
  );
}